'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _contactPersonShape = require('../molecules/contact-person-shape.vue');

var _contactPersonShape2 = _interopRequireDefault(_contactPersonShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {
        'person-image': _contactPersonShape2.default
    },
    props: ['member']
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"team-member\">\n    <person-image :image-id=\"member.image.imageId\" :image=\"member.image.image\"></person-image>\n    <h4 class=\"team-member__title title title--h4\">{{ member.name}}</h4>\n    <p class=\"paragraph team-member__description\">{{{ member.description }}}</p>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-7f8c423b", module.exports)
  } else {
    hotAPI.update("_v-7f8c423b", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}